import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function EditIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 16 16'
    >
      <path
        d='M12.9333 4.89324L11.1066 3.06657C10.8682 2.84264 10.5558 2.71414 10.2288 2.70554C9.90187 2.69694 9.58314 2.80882 9.33329 3.01991L3.33329 9.01991C3.1178 9.23722 2.98362 9.52204 2.95329 9.82657L2.66662 12.6066C2.65764 12.7042 2.67031 12.8026 2.70373 12.8948C2.73715 12.987 2.79049 13.0707 2.85995 13.1399C2.92225 13.2017 2.99612 13.2506 3.07735 13.2838C3.15857 13.3169 3.24555 13.3337 3.33329 13.3332H3.39329L6.17329 13.0799C6.47782 13.0496 6.76264 12.9154 6.97995 12.6999L12.98 6.69991C13.2128 6.45388 13.3387 6.12558 13.3299 5.78693C13.3212 5.44828 13.1786 5.12691 12.9333 4.89324ZM6.05329 11.7466L4.05329 11.9332L4.23329 9.93324L7.99995 6.21324L9.79995 8.01324L6.05329 11.7466ZM10.6666 7.11991L8.87995 5.33324L10.18 3.99991L12 5.81991L10.6666 7.11991Z'
        fill={props.color ?? props.fill}
      />
    </SvgIcon>
  );
}
